<template>
  <div class="template-container">
    <PlaylistFrame :playlist="$store.deviceStartData.main_play_list" />
  </div>
</template>

<script>
import PlaylistFrame from '../PlaylistFrame';

export default {
  components: {
    PlaylistFrame
  }
}
</script>

<style lang="scss" scoped>
.template-container {
  height: 100%;
}
</style>